<script lang="ts">
  /**
   * Connexion au miroir CRM. Distincte du Google OAuth du mail : le compte
   * propriétaire du miroir n'a qu'un provider `email`, et RLS ne reconnaît
   * que cet `auth.uid()` précis. La session est ensuite persistée et
   * rafraîchie par supabase-js — cette saisie n'a lieu qu'une fois.
   */

  import { crmSession, crmSignIn } from "../crm/session.svelte";

  let email = $state("");
  let password = $state("");

  const canSubmit = $derived(
    email.trim().length > 0 && password.length > 0 && !crmSession.busy,
  );

  async function submit(e: Event) {
    e.preventDefault();
    if (!canSubmit) return;
    await crmSignIn(email.trim(), password);
  }
</script>

<section class="card">
  <h2>CRM</h2>
  <p class="muted">
    Le miroir Supabase est protégé par son propre compte. Connecte-toi une
    fois, la session reste ensuite active.
  </p>

  <form onsubmit={submit}>
    <input
      type="email"
      bind:value={email}
      placeholder="Adresse e-mail"
      autocomplete="username"
      autocapitalize="off"
      spellcheck="false"
      required
    />
    <input
      type="password"
      bind:value={password}
      placeholder="Mot de passe"
      autocomplete="current-password"
      required
    />
    {#if crmSession.error}
      <p class="err">{crmSession.error}</p>
    {/if}
    <button class="btn" type="submit" disabled={!canSubmit}>
      {crmSession.busy ? "Connexion…" : "Se connecter"}
    </button>
  </form>
</section>

<style>
  .card {
    max-width: 380px;
    margin: 12vh auto 0;
    padding: 0 24px;
    text-align: center;
  }
  h2 {
    font-family: var(--font-serif);
    font-style: italic;
    font-weight: 400;
    font-size: 31px;
    line-height: 1;
    letter-spacing: -0.015em;
    margin: 0 0 8px;
  }
  .muted {
    color: var(--fg-subtle);
    font-size: 14px;
    line-height: 1.5;
    margin: 0 0 24px;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  input {
    height: 46px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid var(--border);
    background: var(--bg-elev);
    color: var(--fg);
    font-family: var(--font-sans);
    font-size: 16px; /* < 16px déclenche le zoom automatique iOS */
  }
  input:focus {
    outline: none;
    border-color: var(--accent);
  }
  .btn {
    height: 46px;
    margin-top: 6px;
    border: 0;
    border-radius: 12px;
    background: var(--fg);
    color: var(--bg);
    font-family: var(--font-sans);
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
  }
  .btn:disabled {
    opacity: 0.45;
  }
  .err {
    color: var(--bad);
    font-size: 13px;
    margin: 2px 0 0;
    text-align: left;
  }
</style>
